import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionListTemplatesPathParameters } from 'api/actions/revision-list-templates/revision-list-templates-path-parameters';
import { RevisionListTemplatesResponse } from 'api/actions/revision-list-templates/revision-list-templates-response';

type RevisionListTemplatesQueryParameters = Record<string, any>;

/**
 * The path of the RevisionListTemplates action.
 */
export const revisionListTemplatesActionPath = new SweetPath<keyof RevisionListTemplatesPathParameters>(
  '/api/revision/list-templates/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionListTemplates actions.
 */
export default function createRevisionListTemplatesAction(axios: AxiosInstance) {
  return function revisionListTemplatesAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionListTemplatesPathParameters;
    query?: RevisionListTemplatesQueryParameters;
  }) {
    const path = revisionListTemplatesActionPath.insert(parameters);

    return axios.request<RevisionListTemplatesResponse, RevisionListTemplatesResponse>({
      method: 'get',
      url: path,
      params: query,

      headers,
    });
  };
}
